import { css } from 'aphrodite';
import { Row } from '../../../web/components-v2/PageLayout';
import { PortalDestination } from '../../../web/components/Portal';
import { UserOptions } from '../UserOptions';
import { styleSheet } from './styles';

export const CoffeeAppBarNavigationItemPortalDestinationId = 'CoffeeAppBarNavigationItemPortalDestinationId';

/** Main lev's app bar shape, on Coffee's blue, with Coffee's own user menu. */
export const CoffeeAppBar = () => {
	return (
		<Row fullWidth styles={[styleSheet.appBar]}>
			<div className={`app-bar-navigation-item ${css(styleSheet.navItem)}`}>
				<PortalDestination id={CoffeeAppBarNavigationItemPortalDestinationId} />
			</div>
			<div className={css(styleSheet.rightAccessoryContainer)}>
				<UserOptions />
			</div>
		</Row>
	);
};
